import React from 'react';
import { cn } from '../lib/utils';
import { CAMERA_FILTERS, getFilterStyle } from '../lib/cameraFilters';

export function FilterSelector({ selectedFilter, onSelectFilter, previewSrc }) {
  return (
    <div className="w-full">
      <div className="flex gap-3 overflow-x-auto pb-2 px-1 scrollbar-hide">
        {CAMERA_FILTERS.map((filter) => (
          <button
            key={filter.id}
            onClick={() => onSelectFilter(filter.id)}
            className={cn(
              "flex-shrink-0 flex flex-col items-center gap-1 p-2 rounded-xl transition-all",
              selectedFilter === filter.id 
                ? "bg-primary/20 ring-2 ring-primary" 
                : "hover:bg-secondary"
            )}
            data-testid={`filter-${filter.id}`}
          >
            {previewSrc ? (
              <div 
                className="w-14 h-14 rounded-lg overflow-hidden bg-black"
                style={{ filter: getFilterStyle(filter.id) }}
              >
                <img 
                  src={previewSrc} 
                  alt={filter.name}
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div 
                className={cn(
                  "w-14 h-14 rounded-lg flex items-center justify-center text-2xl",
                  selectedFilter === filter.id ? "bg-primary/30" : "bg-secondary"
                )}
              >
                {filter.icon}
              </div>
            )}
            <span className={cn(
              "text-xs font-medium",
              selectedFilter === filter.id ? "text-primary" : "text-muted-foreground"
            )}>
              {filter.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export function FilterPreview({ filterId, children, className }) {
  const filter = CAMERA_FILTERS.find(f => f.id === filterId);
  
  return (
    <div className={cn("relative overflow-hidden", className)}>
      <div style={{ filter: filter?.filter || 'none' }}>
        {children}
      </div>
      {filter?.overlay && (
        <div 
          className="absolute inset-0 pointer-events-none"
          style={{ backgroundColor: filter.overlay }}
        />
      )}
    </div>
  );
}

export default FilterSelector;
